import AppBar from "@material-ui/core/AppBar";
import Avatar from "@material-ui/core/Avatar";
import Badge from "@material-ui/core/Badge";
import Box from "@material-ui/core/Box";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Grow from "@material-ui/core/Grow";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Paper from "@material-ui/core/Paper";
import Popper from "@material-ui/core/Popper";
import { fade, makeStyles } from "@material-ui/core/styles";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import AccountCircle from "@material-ui/icons/AccountCircle";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import MoreIcon from "@material-ui/icons/MoreVert";
import NotificationsIcon from "@material-ui/icons/Notifications";
import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { compose } from "redux";
import { ReactComponent as NotificationBellIcon } from "../../Assets/Images/bell.svg";
import actions from "../../Stores/Auth/actions";
const logoutAction = actions.logout;

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    display: "none",
    color: "black",
    fontSize: "28px",
    fontWeight: "800",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
    textTransform: "capitalize",
    marginRight: "0.4rem",
  },

  bgapp: {
    backgroundColor: "white",
    height: "103px",
    paddingTop: "0.2rem",
    paddingBottom: "0.2rem",
    borderBottom: "2px solid #dee3e7",
    marginBottom: "-7rem",
  },
  headericon: {
    fontSize: "2.5rem",
  },
  notificationicon: {
    width: "30px",
    fill: "#6B747B",
    height: "30px",
  },
  userdropdown: {
    width: "40px",
    height: "40px",
  },
  headerbutton: {
    padding: "12px 20px 12px 20px",
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  userName: {
    fontFamily: "Mulish",
    fontSize: "16px",
    color: "#101928",
    lineHeight: "21px",
    textTransform: "capitalize",
  },
  large: {
    width: "65px",
    height: "65px",
    textTransform: "capitalize",
  },
  traderStatusChip: {
    backgroundColor: "#ACE1AF",
    color: "#000",
    fontSize: "16px",
    lineHeight: "19px",
    padding: "0.4rem 0.6rem",
    fontFamily: "Mulish",
    borderRadius: "8px",
    marginLeft: "0.4rem",
  },
  traderStatusChipDeactive: {
    backgroundColor: "#fd5c63",
    color: "#fff",
    fontSize: "16px",
    lineHeight: "19px",
    fontFamily: "Mulish",
    borderRadius: "8px",
    padding: "0.4rem 0.6rem",
    marginLeft: "0.4rem",
  },
}));

function TabHeader({
  TabTitle,
  status,
  showBackIcon,
  goBackUrl,
  useHistoryToGoBack,
  useStateToGoBack,
  goBackFrom,
  groupId,
  showChip,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const history = useHistory();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const userInfo = useSelector((state) => state.AuthReducer.user);

  // useEffect(() => {
  //   let localId = localStorage.getItem('urbanserve_currentgroup');
  //   if (localId) {
  //     setId(localId);
  //   }
  // });

  const handleRedirect = async () => {
    let localId = await localStorage.getItem("urbanserve_currentgroup");
    history.replace(`/d/services/${localId}/postcode-group`);
  };

  const [badgeName, setbadgeName] = useState();

  useEffect(() => {
    if (userInfo !== null && userInfo?.first_name !== null) {
      let userName = userInfo?.name;
      let badgeName = userName?.charAt(0);
      if (badgeName) {
        setbadgeName(badgeName);
      }
    }
  }, [userInfo]);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };
  const onSignOutAction = (e) => {
    e.preventDefault();
    dispatch(logoutAction(history));
  };

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem
        onClick={() => {
          history.push("/d/myprofile");
        }}
      >
        Profile
      </MenuItem>
      <MenuItem onClick={onSignOutAction}>Logout</MenuItem>
    </Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <IconButton aria-label="show 11 new notifications" color="inherit">
          <Badge badgeContent={11} color="secondary">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <p>Notifications</p>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
        >
          <AccountCircle />
        </IconButton>
        <p>Profile</p>
      </MenuItem>
    </Menu>
  );

  return (
    <div className={classes.grow}>
      <AppBar elevation={0} position="static" className={classes.bgapp}>
        <Toolbar>
          <Typography className={classes.title} variant="h6" noWrap>
            {showBackIcon && (
              <IconButton
                style={{ marginRight: "1rem" }}
                onClick={() =>
                  useHistoryToGoBack
                    ? history.goBack()
                    : goBackFrom === "edit-product"
                    ? handleRedirect()
                    : history.push(goBackUrl)
                }
              >
                <KeyboardBackspaceIcon />
              </IconButton>
            )}
            {TabTitle}
          </Typography>

          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>
            <IconButton
              className={classes.headerbutton}
              aria-label="show 17 new notifications"
              color="#6B747B"
              onClick={handleProfileMenuOpen}
            >
              <Badge color="secondary">
                <NotificationBellIcon className={classes.notificationicon} />
              </Badge>
            </IconButton>
            <IconButton
              ref={anchorRef}
              aria-controls={open ? "menu-list-grow" : undefined}
              aria-haspopup="true"
              onClick={handleToggle}
            >
              <AccountCircle className={classes.userdropdown} />
            </IconButton>
          </div>
          <div className={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </div>
        </Toolbar>
        <div>
          {/* <Button
          ref={anchorRef}
          aria-controls={open ? 'menu-list-grow' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          Toggle Menu Grow
        </Button> */}
          <Popper
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            transition
            disablePortal
            style={{ zIndex: "2" }}
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom" ? "center top" : "center bottom",
                }}
              >
                <Paper style={{ width: "250px", marginRight: "0.5rem" }}>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList
                      autoFocusItem={open}
                      id="menu-list-grow"
                      onKeyDown={handleListKeyDown}
                      style={{ marginTop: "1.4rem" }}
                    >
                      <Box
                        style={{
                          padding: "1rem",
                          borderBottom: "1px solid #dee3e7",
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Avatar className={classes.large}>{badgeName}</Avatar>
                          <div style={{ marginLeft: "0.8rem" }}>
                            <span
                              className={classes.userName}
                              style={{ display: "block", fontSize: "1.8rem" }}
                            >
                              {userInfo !== null ? userInfo?.name : "User"}
                            </span>
                            <span
                              className={classes.profile}
                              style={{
                                display: "block",
                                fontSize: "0.8rem",
                                color: "blue",
                                cursor: "pointer",
                                marginTop: "0.3rem",
                              }}
                              onClick={() => {
                                history.push("/d/myprofile");
                              }}
                            >
                              Your Profile
                            </span>
                          </div>
                        </div>
                      </Box>
                      {/* <MenuItem onClick={handleClose} style={{ padding: '0.8rem'}}>Profile</MenuItem> */}
                      <MenuItem
                        onClick={() => {
                          history.push("/d/change-password");
                        }}
                        style={{ padding: "0.2rem 0.8rem" }}
                      >
                        Change Password
                      </MenuItem>
                      <MenuItem
                        onClick={onSignOutAction}
                        style={{ padding: "0.2rem 0.8rem" }}
                      >
                        Logout
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </div>
  );
}
function mapDispatchToProps(dispatch) {
  return {
    logout: (history) => dispatch(logoutAction(history)),
  };
}

const withConnect = connect(null, mapDispatchToProps);
export default compose(withConnect)(TabHeader);
